<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  export let name, x, y, url, hover;

  let visited = false;
  function pressed() {
    visited = true;
    dispatch("pressed", {
      name,
    });
  }
</script>

<div style="top:{y}%; left:{x}%;" on:click={pressed}>
  <img alt="wicked womens guide to {name}" src={url} />
  <img alt="wicked womens guide to {name}" src={hover} class:visited />
</div>

<style>
  div {
    position: absolute;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
  }

  div > img:last-of-type {
    visibility: hidden;
  }
  div:hover > img:last-of-type {
    visibility: visible;
    cursor: pointer;
  }

  .visited {
    visibility: visible !important;
  }
</style>
